import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import useStore, { selectCountryTheme, selectFavoriteCountryId } from '@/hooks/client/useStore';

/**
 * Main logo for each country brand
 * @returns {JSX.Element}
 */
const Logo = ({ sx = '' }) => {
  const countryTheme = useStore(selectCountryTheme);
  const countryCode = useStore(selectFavoriteCountryId);

  return (
    <Box
      component="img"
      src={`/images/${countryCode}/logo.svg`}
      alt="Logo"
      sx={{
        width: countryTheme.logoWidth,
        height: countryTheme.logoHeigth,
        marginY: '0.6rem',
        ...sx,
      }}
    />
  );
};

Logo.propTypes = {
  sx: PropTypes.object,
};

export default Logo;
